import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function HelpDialogContent() {
  return (
    <Box sx={{ mb: "3em" }}>
      <Typography>
        Please click{" "}
        <a
          target="_blank"
          href={`${process.env.PUBLIC_URL}/resources/MS-DOH-INDUSTRY-TM.pdf`}
          rel="noopener noreferrer"
        >
          here to view the training material
        </a>
      </Typography>
      <Typography>
        You can quickly find answers to Frequently Asked Questions (FAQS){" "}
        <a href="https://appengine.egov.com/apps/ms/medicalcannabis/FAQ">
          here
        </a>
      </Typography>
      <Typography>
        If you are a dispensary and have a policy or procedural question, please
        contact the Mississippi Department of Revenue (MS DOR) at{" "}
        <a href="mailto:abcpermitdepartment@dor.ms.gov" target="_top">
          abcpermitdepartment@dor.ms.gov
        </a>
        <>
          <span> or </span>
          <a href="tel:601-923-7690">601-923-7690</a>{" "}
        </>
        . Thank you!
      </Typography>

      <Typography>
        If you are an Individual (Patient, Practitioner, Caregiver, Agent) or a
        business other than dispensary and have a policy or procedural question,
        please contact the Mississippi Department of Health(MSDH) at{" "}
        <a href="mailto:MCLicensing@msdh.ms.gov" target="_top">
          MCLicensing@msdh.ms.gov
        </a>
        <>
          <span> or </span>
          <a href="tel:601-206-1540">601-206-1540</a>{" "}
        </>
        . Thank you!
      </Typography>

      <Typography>
        For technical support and payment questions, please contact NIC
        Mississippi at{" "}
        <a href="mailto:nlssupport-ms-doh@tylertech.com" target="_top">
          nlssupport-ms-doh@tylertech.com
        </a>
        <>
          <span> or </span>
          <a href="tel:601-351-5023">601-351-5023</a>
        </>
        . Thank you!
      </Typography>
    </Box>
  );
}

export default HelpDialogContent;
